import { createAsyncThunk } from '@reduxjs/toolkit';
import { uploadToS3 } from '../../utils/s3Upload';

interface UploadToS3Args {
  signedUrl: string;
  file: File;
  contentType: string;
  uploadInstructions?: { headers: Record<string, string> }; // Optional additional headers
}

export const uploadToS3Thunk = createAsyncThunk<
  boolean,
  UploadToS3Args
>('s3/uploadToS3', async ({ signedUrl, file, contentType, uploadInstructions }, { rejectWithValue }) => {
  try {
    const result = await uploadToS3(signedUrl, file, contentType, uploadInstructions);
    return result;
  } catch (error: any) {
    return rejectWithValue(error?.message || 'Upload failed');
  }
});
